module.exports = __webpack_public_path__ + "static/media/GreenIT.fdbf6b32.png";